// NOTE: this file is deprecated and only intended to be used with the v1 API
import { RequestInterceptor } from '@rails/request.js';

import { currentChannelShareKey, currentShadowId, currentWorkspaceId, getMetaContent } from './meta';

export const attachWorkspaceIdToRequests = () => {
  RequestInterceptor.register(async (request) => {
    // always include credentials for cross-subdomain API requests
    if (request.url.includes(`api.${getMetaContent('env:default_host')}`)) request.options.credentials = 'include';

    // attach the current workspace ID to the request if there is one
    if (currentWorkspaceId()) request.addHeader('X-Workspace-Id', currentWorkspaceId());

    // attach the current shadow ID for public channel access
    if (currentShadowId()) request.addHeader('X-Shadow-Id', currentShadowId());

    // shared channel access requires the original shared channel key with every request to protect against key revocation
    // this applies to both shadows and profiles accessing via shared channel URLs
    if (currentChannelShareKey()) request.addHeader('X-Shared-Channel-Key', currentChannelShareKey());
  });
};

export const apiRoute = (path) => {
  if (path.includes('/v2')) throw new Error('v2 API routes are not supported via this helper');

  return `https://api.${getMetaContent('env:default_host')}${path}`;
};

export function readResponseStatus(response) {
  const candidates = [response?.statusCode, response?.status, response?.response?.status];

  for (const candidate of candidates) {
    if (Number.isFinite(candidate)) return candidate;
  }

  return null;
}
